export const FILE_COUNT_LIMIT = 50;
export const DIRECTORY_COUNT_LIMIT = 10;
export const MAX_GB_VERSION_FILES = 1;
export const MAX_BYTES_VERSION_FILES = MAX_GB_VERSION_FILES * 1024 * 1024 * 1024; // byte
export const BYTES_EQUAL_TWO_HUNDRED_MB = 209715200;
